import { Tooltip } from 'antd';
import { CSSProperties, useEffect, useRef, useState } from 'react';
import { DEFAULT_PLACEHOLDER } from 'utils/constants';

type Props = {
  text?: string;
  maxWidth?: string | number;
};

const tooltipStyle: CSSProperties = {
  whiteSpace: 'nowrap',
  overflow: 'hidden',
  textOverflow: 'ellipsis',
};

const RevxTextWithTooltip = ({ text = '', maxWidth = 100 }: Props) => {
  const [isOverflow, setIsOverflow] = useState(false);
  const containerRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const containerWidth = containerRef?.current?.offsetWidth;
    if (!containerWidth) return;
    const textRenderedWidthElement = document.createElement('span');
    textRenderedWidthElement.innerText = text;
    textRenderedWidthElement.style.whiteSpace = 'nowrap';
    containerRef.current?.appendChild(textRenderedWidthElement);
    const textRenderedWidth = textRenderedWidthElement.offsetWidth;
    containerRef.current?.removeChild(textRenderedWidthElement);
    setIsOverflow(textRenderedWidth > containerWidth);
  }, [text]);

  const displayText = text || DEFAULT_PLACEHOLDER;
  const isPlaceholder = displayText === DEFAULT_PLACEHOLDER;

  const tooltipContent = (
    <div style={{ ...tooltipStyle, paddingLeft: isPlaceholder ? '6px' : '0' }}>
      {displayText}
    </div>
  );

  return (
    <div className="text-with-tooltip" ref={containerRef} style={{ maxWidth }}>
      {isOverflow ? (
        <Tooltip title={text}>{tooltipContent}</Tooltip>
      ) : (
        tooltipContent
      )}
    </div>
  );
};

export default RevxTextWithTooltip;
